import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../common/SearchComponent';

class CreditNotesSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'common:label.startDate',
      name: 'startDate',
      type: 'date',
      isClearable: true,
    },
    {
      label: 'common:label.endDate',
      name: 'endDate',
      type: 'date',
      isClearable: true,
    },
    {
      label: 'common:label.noteType',
      name: 'type',
      type: 'select',
      tOptions: 'selections:arNotesType',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-3';
}

CreditNotesSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

CreditNotesSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(CreditNotesSearchForm);
